// format form reponse to remove empty fields
export const formatObject = (data: any) => {
  const mappedData = Object.entries(data).reduce((pv: any, cv: any) => {
    if (typeof cv[1] === "object") {
      if (cv[1] === null) return pv;

      let nestedData;
      if (Array.isArray(cv[1])) {
        // handle array

        if (typeof cv[1][0] === "object") {
          nestedData = cv[1].map((value: any) => formatObject(value));
          pv[cv[0]] = nestedData;
        } else if (typeof cv[1][0] === "undefined") {
          return pv;
        } else {
          pv[cv[0]] = cv[1];
        }
      } else {
        nestedData = formatObject(cv[1]);
        if (Object.keys(nestedData).length) {
          pv[cv[0]] = nestedData;
        }
      }

      return pv;
    } else if (typeof cv[1] === "string") {
      if (cv[1].trim().length === 0) {
        return pv;
      } else {
        pv[cv[0]] = cv[1].trim();
        return pv;
      }
    } else if (typeof cv[1] === "number") {
      pv[cv[0]] = cv[1];
      return pv;
    } else {
      return pv;
    }
  }, {});

  return mappedData;
};
